// 用于存放 环境文件
import cookies from "js-cookie";
import { WenJuanRootUrl, BasicUrl, WenJuanBmsUrl } from "config/config";

const host = window.location.hostname;
export function isTestEnv() {
  // return (
  //   host === "test-front-base.survey.work" ||
  //   host === "test.front.base.survey.work" ||
  //   host === "localhost"
  // );
  return process.env.REACT_APP_CURRENT === "test";
}
// 根据环境获取url
export const getEnvUrl = ([
  testUrl,
  proUrl,
  taskUrl,
  isAdmin,
  noHash,
  hashUrl,
  noToken
]) => {
  const isTest = isTestEnv();
  const domainUrl = isTest ? testUrl : proUrl;
  const token = `?token=${
    isAdmin ? cookies.get("adminShorcuts") : cookies.get("shorcuts")
  }`;
  let url = "";
  // hash方式
  if (!noHash) {
    url = domainUrl + (noToken ? "" : token) + (taskUrl ? "#" + taskUrl : "");
  } else if (hashUrl) {
    url = domainUrl + taskUrl + (noToken ? "" : token) + hashUrl;
  } else {
    url = domainUrl + taskUrl + (noToken ? "" : token);
  }
  console.log(url);
  return url;
};
// 问卷吧【管理端】测试域名
export const wjbTestDomain = WenJuanBmsUrl[process.env.REACT_APP_CURRENT];
// 问卷吧【管理端】生产域名
export const wjbProductionDomain = WenJuanBmsUrl[process.env.REACT_APP_CURRENT];

// 问卷吧【客户端】测试域名
export const wjbCustomerTestDomain = `${
  WenJuanRootUrl[process.env.REACT_APP_CURRENT]
}`;
// "http://dygc.c952463b958c1435894b4e05e6b6d0189.cn-beijing.alicontainer.com";
// 问卷吧【客户端】生产域名
export const wjbCustomerProductionDomain = `${
  WenJuanRootUrl[process.env.REACT_APP_CURRENT]
}`;

// 问卷吧【移动端H5】测试域名
export const wjbH5TestDomain = `${
  WenJuanRootUrl[process.env.REACT_APP_CURRENT]
}/m/`;
// 问卷吧【移动端H5】生产域名
export const wjbH5ProductionDomain = `${
  WenJuanRootUrl[process.env.REACT_APP_CURRENT]
}/m/`;

// 论文查重【客户端】测试域名
export const lwccTestDomain = "http://172.17.109.137:4333";
// 论文查重【客户端】生产域名
export const lwccProductionDomain = "https://paper.survey.work";
// 调研工厂首页后台【管理端】生产域名
export const dysyhtProductionDomain = "https://admin2.survey.work";

// 调研工厂home 域名（测试）
export const vueAppDygcTestHome = `${
  BasicUrl[process.env.REACT_APP_CURRENT]
}/theHome`;
// 调研工厂home 域名（生产）
export const vueAppDygcProductionHome = `${
  BasicUrl[process.env.REACT_APP_CURRENT]
}/survey`;
